import { addComponent, removeComponent } from "bitecs";
import {
  RemoteRight,
  RemoteLeft,
  HandRight,
  HandLeft,
  RemoteHoverTarget,
  NotRemoteHoverTarget,
  RemoveNetworkedEntityButton,
  DestroyAtExtremeDistance,
  Billboard,
  AvatarPOVNode
} from "./bit-components";

[
  ["remote-right", RemoteRight],
  ["remote-left", RemoteLeft],
  ["hand-right", HandRight],
  ["hand-left", HandLeft],
  ["is-remote-hover-target", RemoteHoverTarget],
  ["is-not-remote-hover-target", NotRemoteHoverTarget],
  ["remove-networked-object-button", RemoveNetworkedEntityButton],
  ["destroy-at-extreme-distances", DestroyAtExtremeDistance],
  // ["billboard", Billboard],
  ["avatar-pov-node", AvatarPOVNode]
].forEach(([aframeComponentName, bitecsComponent]) => {
  AFRAME.registerComponent(aframeComponentName, {
    init: function () {
      addComponent(APP.world, bitecsComponent, this.el.object3D.eid);
    },
    remove: function () {
      removeComponent(APP.world, bitecsComponent, this.el.object3D.eid);
    }
  });
});

AFRAME.registerComponent("billboard", {
  schema: {
    onlyY: { type: "boolean", default: false }
  },
  init: function () {
    const eid = this.el.object3D.eid;
    addComponent(APP.world, Billboard, eid);
    if (this.data.onlyY) {
      Billboard.onlyY[eid] = 1;
    }
  },
  update: function () {
    const eid = this.el.object3D.eid;
    Billboard.onlyY[eid] = this.data.onlyY ? 1 : 0;
  },
  remove: function () {
    removeComponent(APP.world, Billboard, this.el.object3D.eid);
  }
});
